import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppContainer from './components/app/AppContainer';
import { BrowserRouter } from 'react-router-dom';
import AppContext, { AppContextProvider } from "./components/app/context/AppContext";

const appHost: string = process.env.REACT_APP_APP_HOST + '';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/" >
      <AppContextProvider>
        <AppContainer />
      </AppContextProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
